<mat-accordion>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ faqItem.question }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <p>{{ faqItem.answer }}</p>
    <div id="feedback">
      <p>Este conteúdo foi útil?</p>
      <svg id="thumbs_up" 
      width="20"
      height="18" 
      fill="none"
      viewBox="0 0 20 18"
      (click)="onClick(true)"
      xmlns="http://www.w3.org/2000/svg">
        <path [attr.fill]="faqItem.wasUseful ? '#066554' : '#6F6F6F'"
        d="M0 18H2C2.55 18 3 17.55 3 17V8C3 7.45 2.55 7 2 7H0V18ZM19.83 10.88C19.94 10.63 20 10.36
        20 10.08V9C20 7.9 19.1 7 18 7H12.5L13.42 2.35C13.47 2.13 13.44 1.89 13.34 1.69C13.11 1.24 12.82 
        0.83 12.46 0.47L12 0L5.59 6.41C5.21 6.79 5 7.3 5 7.83V15.67C5 16.95 6.05 18 7.34 18H15.45C16.15 
        18 16.81 17.63 17.17 17.03L19.83 10.88Z" fill="#066554"/>
      </svg>
      <svg id="thumbs_down"
      width="20"
      height="18"
      fill="none"
      viewBox="0 0 20 18" 
      (click)="onClick(false)"
      xmlns="http://www.w3.org/2000/svg">
        <path [attr.fill]="faqItem.wasUseful == false ? '#EB194B' : '#6F6F6F'"
        d="M20 0H18C17.45 0 17 0.45 17 1V10C17 10.55 17.45 11 18 11H20V0ZM0.17 7.12C0.0600001 7.37 
        0 7.64 0 7.92V9C0 10.1 0.9 11 2 11H7.5L6.58 15.65C6.53 15.87 6.56 16.11 6.66 16.31C6.89 16.76 7.18 
        17.17 7.54 17.53L8 18L14.41 11.59C14.79 11.21 15 10.7 15 10.17V2.34C15 1.05 13.95 0 12.66 0H4.56C3.85 
        0 3.2 0.37 2.84 0.97L0.17 7.12Z" fill="#EB194B"/>
      </svg>
    </div>
  </mat-expansion-panel>
</mat-accordion>